import { useTranslation } from "react-i18next";
import { DialogWrapper } from "../../../../../../shared/components/common/dialogWrapper";
import { Box } from "@mui/material";
import { FsButton } from "../../../../../../shared/components/button";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Toaster } from "../../../../../../shared/components/common/toaster";

export const APIKeyDialog = ({ state, onClose = () => { }, apiKey = null }) => {
  const { t } = useTranslation();

  const onCopy = () => {
    navigator.clipboard.writeText(apiKey);
    Toaster({ msg: "Copied...", isError: false });
  };

  return (
    <DialogWrapper
      hideCloseBtn={true}
      maxWidth="sm"
      state={state}
      preventOutsideClick
      title={t('apiKeyToken')}
      onClose={() => {
        onClose(false);
      }}
      content={
        <Box className="flex flex-col justify-center items-center p-4">
          <Box className='flex items-center justify-center'>
            <Box className='bg-gray-200 flex items-center min-h-[34px] shadow-sm p-2 rounded-md font-semibold text-[13px] my-3'>
              {apiKey}
            </Box>
            <Box onClick={() => {
              onCopy();
            }} className='border mx-1 cursor-pointer hover:bg-gray-100 flex items-center border-solid shadow-sm p-2 min-h-[34px] rounded-md'>
              <ContentCopyIcon className="!text-[14px]" />
            </Box>
          </Box>
          <Box className='text-[12px] caption'>
            {t('thisIsYourApiKeyWarningText')}
          </Box>
          <Box className="flex items-center justify-center w-full mt-4">
            <FsButton
              onClick={() => {
                onClose(true);
              }}>{t('close')}</FsButton>
          </Box>
        </Box>
      }
    ></DialogWrapper>
  );
};